import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';

function App() {
  return (
    <Router>
      <AuthWrapper />
    </Router>
  );
}

export default App;
